import { h, ref, createApp, onMounted, onBeforeUpdate } from "vue";
export default {
  name: "RenderToIFrame",
  props: {
    css: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {
    iframeBody: function (val) {},
  },
  setup(props, { slots }) {
    const iframeRef = ref(null);
    const iframeBody = ref(null);
    const iframeHead = ref(null);
    const iframeStyle = ref(null);
    const iframeLink = ref(null);
    let iframeApp = null;

    onMounted(() => {
      // #this setTimeout is just a hack to insert iframe for the dom like Mozilla firefox
      setTimeout(() => {
        iframeBody.value = iframeRef.value.contentDocument.body;
        iframeHead.value = iframeRef.value.contentDocument.head;
        iframeLink.value = document.createElement("link");
        iframeLink.value.href = `${process.env.VUE_APP_CHATWIDGET_HOST_URL}/chatwidgetmultiple/css/app.css`;
        iframeLink.value.rel = "stylesheet";
        const el = document.createElement("div");
        iframeBody.value.appendChild(el);
        iframeStyle.value = document.createElement("style");
        iframeStyle.value.innerHTML = props.css;
        iframeHead.value.appendChild(iframeStyle.value);
        iframeHead.value.appendChild(iframeLink.value);
        iframeApp = createApp({
          name: "iframeRender",
          setup() {
            return () => slots.default();
          },
        }).mount(el);
      }, 0);
    });
    onBeforeUpdate(() => {
      if (!iframeApp || !iframeRef.value) {
        return;
      }
      if (props.css) {
        iframeStyle.value.innerHTML = props.css;
      }
    });
    return () => {
      return h("iframe", { ref: iframeRef });
    };
  },
};
